var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Actions"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5415 3.18294C5.5415 2.37753 6.19443 1.72461 6.99984 1.72461C7.80525 1.72461 8.45817 2.37753 8.45817 3.18294C8.45817 3.98835 7.80525 4.64128 6.99984 4.64128C6.19443 4.64128 5.5415 3.98835 5.5415 3.18294ZM6.99984 9.30794C7.80525 9.30794 8.45817 8.65502 8.45817 7.84961C8.45817 7.0442 7.80525 6.39128 6.99984 6.39128C6.19443 6.39128 5.5415 7.0442 5.5415 7.84961C5.5415 8.65502 6.19443 9.30794 6.99984 9.30794ZM6.99984 13.9746C7.80525 13.9746 8.45817 13.3217 8.45817 12.5163C8.45817 11.7109 7.80525 11.0579 6.99984 11.0579C6.19443 11.0579 5.5415 11.7109 5.5415 12.5163C5.5415 13.3217 6.19443 13.9746 6.99984 13.9746Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/Actions.e137f8cd7bc6ef8fbed8c0de14f89dcd.svg";
export { ForwardRef as ReactComponent };